import FileUploadSuccess from "./FileUploadSuccess";
export default FileUploadSuccess;
